<template>
<div class="shortmessagelist"  >
    <div class="top">
        <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
        <el-select v-model="type" placeholder="请选择类型" size="medium" @change="listByModels()">
                    <el-option  :value="0"  label="全部全部充值类型"></el-option>
                    <el-option  :value="1"  label="客服充值"></el-option>
                    <el-option  :value="2"  label="在线充值"></el-option>
                    <el-option  :value="3"  label="线下充值"></el-option>
                </el-select>
    </div>
     <el-table stripe :data="dataList"  :height="`${windowHeight-180}px`" border style="width: 100%">
             <el-table-column  label="购买条数" show-overflow-tooltip align="center" >
                <template slot-scope="scope">
                    {{scope.row.count?scope.row.count:0}}
                </template>
            </el-table-column>
             <el-table-column label="原价" align="center">
                <template slot-scope="scope">
                      ￥ {{scope.row.money?scope.row.money:0}}
                </template>
            </el-table-column>
            <el-table-column label="支付金额" align="center">
                <template slot-scope="scope">
                       ￥ {{scope.row.realMoney?scope.row.realMoney:0}}
                </template>
            </el-table-column>
            <el-table-column label="操作员" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.createUserName}}
                </template>
            </el-table-column>
            <el-table-column label="备注" align="center">
                <template slot-scope="scope">
                        {{scope.row.remark}}
                </template>
            </el-table-column>
            <el-table-column label="审批人" align="center">
                <template slot-scope="scope">
                        {{scope.row.approverName}}
                </template>
            </el-table-column>
            <el-table-column label="时间" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                          {{(scope.row.state==2||scope.row.state==3)?(scope.row.approveTime?scope.row.approveTime.substring(0, 19):"----"):(scope.row.createTime?scope.row.createTime.substring(0, 19):"----")}}
                </template>
            </el-table-column>
            <el-table-column label="支付方式" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.type==1">客服充值</span>
                     <span v-if="scope.row.type==2">在线充值</span>
                    <image-previewer tag="richtext" v-if="scope.row.type==3">
                          <img class="picimg" :src="scope.row.picJson" alt="" v-if="scope.row.type==3">
                    </image-previewer>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                       <el-tag v-if="scope.row.state==3" type="danger"  size="mini">被驳回</el-tag>
                       <el-tag v-else-if="scope.row.state==1" type="info"  size="mini">草稿</el-tag>
                       <el-tag v-else-if="scope.row.state==2" size="mini">同意</el-tag>
                       <el-tag v-else-if="scope.row.state==4" type="success"  size="mini">已充值</el-tag>
                       <el-tag v-else-if="scope.row.state==5" type="warning"  size="mini">待确认</el-tag>
                </template>
            </el-table-column>
              <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="deleteByIds(scope.row.id)" :disabled="!(scope.row.state==1||scope.row.state==3)" type="text" size="small">删除</el-button>
                         <el-button :disabled="!(scope.row.state==5&&scope.row.type==3)" @click.native.prevent="isShowBatchAddCharfun(scope.row.id)"  type="text" size="small">审批确认</el-button>
                    </template>
            </el-table-column>
        </el-table>
        <el-dialog title="审批确认" :visible.sync="isShowBatchAddChar" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
                    <el-form-item label="购买条数" prop="count">
                         <el-input-number v-model="form.count" :precision="0" :step="1" :min="1" :max="1000000" placeholder="请输入购买条数" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="原价" >
                         {{form.count/10}}
                    </el-form-item>
                     <el-form-item label="支付金额" prop="realMoney">
                         <el-input-number v-model="form.realMoney" :precision="1" :step="0.1" :min="0.1" :max="100000" placeholder="请输入支付金额" ></el-input-number>
                    </el-form-item>

                    <el-form-item label="备注" prop="remark">
                        <el-input placeholder="请输入备注" type="textarea" :maxlength="500" :rows="5" v-model.trim="form.remark"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowBatchAddChar = false">取 消</el-button>
                 <el-button size="medium" type="primary" @click="approves(3)">不同意</el-button>
                <el-button size="medium" type="primary" @click="approves(2)">同意</el-button>
            </span>
        </el-dialog>
</div>
</template>
<script>
import {listByModel,approve,deleteById} from "@/api/shortmessage";
import mixin from "@/mixins/windowResize";
import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';
export default {
  data() {
    return {
     schoolId:this.$route.query.schoolId,
     schoolName: this.$route.query.schoolName,
     type:0,
     dataList:[],
     isShowBatchAddChar:false,
     form:{
         id:"",
         remark:"",
         state:2,
         count:1,
         realMoney:0.1,
         money:0
     },
     formRules:{
         remark:[{ required: true, message: '请输入备注', trigger: 'blur' }],
         count:[{ required: true, message: '请输入购买条数', trigger: 'change' }],
         realMoney:[{ required: true, message: '请输入支付金额', trigger: 'change' }]
     }

    };
  },
  components: {ImagePreviewer},
  mixins: [mixin],
  created() {
      this.listByModels();
  },
  methods: {
      isShowBatchAddCharfun(id){
        this.form.id=id;
        this.isShowBatchAddChar=true;
      },
      approves(num){
          this.$refs.form.validate(isValid => {
                    if(isValid) {
                       this.form.state=num;
                       this.form.money=this.form.count/10;
                        approve(this.form).then(res => {
                            this.$message({
                                type: 'success',
                                message: '审批核成功!'
                            });
                            this.listByModels();
                            this.form.count=1;
                            this.form.remark="";
                            this.form.realMoney=0.1;
                            this.isShowBatchAddChar=false;
                        }).catch();
                    }
                })

      },
      listByModels(){
          listByModel(this.schoolId,this.type)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data;
                    }).catch(err => {
                })
      },
      //删除
      deleteByIds(id){
          this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteById(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.listByModels();
                    }).catch();

                }).catch(() => {
                });
      }

  }
};
</script>
<style lang="scss" scoped>
.shortmessagelist {
   padding: 12px;
  .top {
    padding-bottom: 10px;
    overflow: hidden;
  }
  .picimg{
      height: 28px;
      max-width:50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shortmessage/shortmessagelist.vue